import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <div className="w-full flex justify-center items-center bg-white bg-opacity-70 text-black">
      <div className="w-11/12 flex flex-wrap justify-between items-start px-5 gap-y-5 py-10 tracking-wide">
        <div className="flex flex-col items-start justify-center">
          <div className="flex gap-x-3 text-2xl pb-5">
            <img src="logo/logo.png" alt="logo" width={80} />
            <h2>
              An IT <br /> Solution <br />
              Company
            </h2>
          </div>
          <p>
            An IT Solution Company,<br />
            11th Ave, Gaur City 2, <br />
          </p>
          <p>PHONE: (+91) 7895927366<br /> E-MAIL: anitsolutions0707@gmail.com</p>
        </div>
        <div className="hidden md:flex flex-col items-start justify-center gap-y-3">
          <h2 className="font-semibold text-2xl pb-5">EXPLORE</h2>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/solutions">Solutions</NavLink>
          <NavLink to="/about">About Us</NavLink>
        </div>
        <div className="hidden md:flex flex-col items-start justify-center gap-y-3">
          <h2 className="font-semibold text-2xl pb-5">COMPANY</h2>
          <NavLink to="/">Meet the Team</NavLink>
          <NavLink to="/solutions">Join the Team</NavLink>
          <NavLink to="/about">Testimonials</NavLink>
        </div>
        <div className="flex flex-col items-center justify-center gap-y-3">
          <h2 className="font-semibold text-2xl pb-5">LET'S STAY IN TOUCH</h2>
          <input type="text" placeholder="Name" className="rounded-lg px-2 py-1"/>
          <input type="email" placeholder="Email" className="rounded-lg px-2 py-1"/>
          <button className="px-5 py-2 rounded-lg bg-white bg-opacity-20 shadow-xl">Subscribe</button>
        </div>
      </div>
    </div>
  );
}

export default Footer;
